<!-- 聊天窗口 -->
<template>
        <div id="chatContent" class="chat-content" @click="closeMenu">
            <div v-if="pageSize === 'large' || otherSys !== 'applet'" class="title">{{userName}}</div><!--小程序要去掉头部-->
            <div v-if="pageSize === 'large' || otherSys !== 'applet'" class="title-button">
                <div v-if="clickItem.type === 1 && (pageType === '2' && otherSys === 'ris')" id="ris-button" :class="[pageSize === 'small' ? 'button-icon':'','icon','iconfont','icon-huanzhejilu-cu-fill','more-icon-2','cursor']" @click="risButtonClick"></div>
                <div v-if="clickItem.type === 1 " id="setting-button" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-qunguanli','more-icon','cursor']" @click="settingClick(true)"></div>
                <!-- <div v-if="clickItem.type === 1 && clickItem.groupStatus === 1 && otherSys === 'applet'" title="关闭会话"  :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-jieshu','more-icon','cursor']" @click="finishChat"></div> -->
            </div>
            <!--小程序医生界面需添加患者主诉--><!--主任说医生头部先不要-->
            <!-- <div v-if="otherSys === 'applet' && userType === 1" class="pat-top-info" @click="patDialogShow = true">
                <span v-if="patInfo && patInfo.patName">{{patInfo.patName}} {{patInfo.sex===1 ? '男':'女'}}/{{patInfo.age}} </span>
                <span v-else>无患者信息</span>
                <span v-if="surplusTime !== '已结束' && !closedChat" class="close-button" @click.stop="finishChat">关闭会话</span>
            </div> -->
            <!--小程序患者界面需添加剩余到期时间-->
            <!-- <div v-if="otherSys === 'applet' && userType === 0 " class="quest-top-info">
                <div v-if="surplusTime !== '已结束' && !closedChat">
                    <span>问诊中</span>
                    <span class="sub-title">{{surplusTime}} 后结束</span>
                </div>
                <span v-else>会话已结束</span>
            </div> -->
            <div class="content-micro">
                <div id="divContent">
                    <div v-for="(item,index) in chatList" :key="index" class="chart-div">
                        <!--普通消息-->
                        <div :class="['left-chart','one-chart',item.checked ? 'checked-chart':'']" v-if="item.chatType === 0 && item.chatPosition === 'left'" @click="clickAndCheck(item,item.content)">
                            <el-checkbox v-if="showCheckbox" class="msg-checkbox-left" v-model="item.checked" @change="checkData(item.content,$event)" @click.native.stop="()=>{}"></el-checkbox>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line">
                                    <span class="message-content" @touchstart="down($event,['copy'],item)" @touchend="up" @click="msgClick($event)" @contextmenu.prevent="showRightMenu($event,[],item,'left')" v-html="item.content"></span>
                                </div>
                            </div>
                        </div>
                        <div :class="['right-chart','one-chart',item.checked ? 'checked-chart':'']" v-if="item.chatType === 0 && item.chatPosition === 'right'" @click="clickAndCheck(item,item.content)">
                            <div class="chart-line">
                                <span class="message-content" @touchstart="down($event,['revocation','copy'],item)" @touchend="up" @click="msgClick($event)" @contextmenu.prevent="showRightMenu($event,['revocation'],item,'right')" v-html="item.content"></span>
                            </div>
                            <el-checkbox v-if="showCheckbox" class="msg-checkbox-right" v-model="item.checked" @change="checkData(item.content,$event)" @click.native.stop="()=>{}"></el-checkbox>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <!--图片消息-->
                        <div class="left-chart one-chart" v-if="item.chatType === 1 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line">
                                    <span class="message-content" @touchstart="down($event,['copy'],item)" @touchend="up" @click="msgClick($event)" @contextmenu.prevent="showRightMenu($event,[],item,'left')">
                                        <el-image style="max-width:200px;width:auto;height:auto" :src="item.content" :preview-src-list="imgList"></el-image>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="right-chart one-chart" v-if="item.chatType === 1 && item.chatPosition === 'right'">
                            <div class="chart-line">
                                <span class="message-content" @touchstart="down($event,['revocation','copy'],item)" @touchend="up" @click="msgClick($event)" @contextmenu.prevent="showRightMenu($event,['revocation'],item,'right')">
                                    <el-image style="max-width:200px;width:auto;height:auto" :src="item.content" :preview-src-list="imgList"></el-image>
                                </span>
                            </div>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <!--语音-->
                        <div class="right-chart one-chart" v-if="item.chatType === 4 && item.chatPosition === 'right'">
                            <div class="chart-line cursor" @click="voiceLineClick(item)">
                                <span class="message-content voice-block flex-right" :style="`width:${item.content.width}px`" @touchstart="down($event,['revocation'],item)" @touchend="up" @click="msgClick($event)" @contextmenu.prevent="showRightMenu($event,['revocation','word'],item,'right')">
                                    <div :class="['trumpet','trumpet-right',item.voicePlay ? 'voicePlay':'']"></div>
                                    <div class="inline-block">{{item.content.Time}}"</div>
                                    <div v-if="item.content.word" class="voice-word-right">{{item.content.word}}</div>
                                </span>
                            </div>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <div class="left-chart one-chart" v-if="item.chatType === 4 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line cursor" @click="voiceLineClick(item)">
                                        <span class="message-content voice-block flex-left" :style="`width:${item.content.width}px`" @touchstart="down($event,[],item)" @touchend="up" @click="msgClick($event)" @contextmenu.prevent="showRightMenu($event,['word'],item,'left')">
                                            <div class="flex-item">
                                                <div class="inline-block">{{item.content.Time}}"</div>
                                                <div :class="['trumpet','trumpet-left',item.voicePlay ? 'voicePlay':'']"></div>
                                                <div v-if="item.content.word" class="voice-word-left">{{item.content.word}}</div>
                                            </div>
                                        </span>
                                </div>
                            </div>
                        </div>
                        <!--时间消息-->
                        <div class="time-msg" v-if="item.chatType === 99">{{item.createdTime}}</div>
                        <!--附件消息-->
                        <div class="right-chart one-chart" v-if="item.chatType === 2 && item.chatPosition === 'right'">
                            <span class="chart-line message-content">
                                <div class="t-c file-box file-box-right">
                                    <img :src="require('../../assets/file/'+item.content.typeImg)"/>
                                    <div class="file-text">
                                        <div class="file-name">{{item.content.fileOriginName}}</div>
                                        <div class="file-size ft-l">{{item.content.fileSizeKb}}KB</div>
                                        <a v-if="!isWeiXin" class="inline-block ft-r" href="javascript:void(0);" @click="downloadFile(item.content.id,item.content.fileOriginName)">下载附件</a>
                                        <a v-else class="inline-block ft-r" href="javascript:void(0);" @click="weixinPreview(item.content.id,item.content.fileSuffix)">查看附件</a>
                                        <!-- <a class="inline-block ft-r mr-15" href="javascript:void(0);" @click="previewFile(item.content.id,item.content.fileOriginName)">在线预览</a> -->
                                    </div>
                                </div>
                            </span>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <div class="left-chart one-chart" v-if="item.chatType === 2 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <span class="chart-line message-content">
                                    <div class="t-c file-box">
                                        <img :src="require('../../assets/file/'+item.content.typeImg)"/>
                                        <div class="file-text">
                                            <div class="file-name">{{item.content.fileOriginName}}</div>
                                            <div class="file-size ft-r">{{item.content.fileSizeKb}}KB</div>
                                            <a v-if="!isWeiXin" class="inline-block ft-l" href="javascript:void(0);" @click="downloadFile(item.content.id,item.content.fileOriginName)">下载附件</a>
                                            <a v-else class="inline-block ft-l" href="javascript:void(0);" @click="weixinPreview(item.content.id,item.content.fileSuffix)">查看附件</a>
                                            <!-- <a class="inline-block ft-l ml-15" href="javascript:void(0);" @click="previewFile(item.content.id,item.content.fileSuffix)">在线预览</a> -->
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <!--群组/系统消息-->
                        <div class="other-msg" v-if="item.chatType === 5">
                            <span>{{item.content}}</span>
                        </div>
                        <!--评价--><!--最后一条消息才显示服务评价-->
                        <div class="evaluate-box" v-if="item.chatType === 5 && item.content === '会话已结束' && index === chatList.length - 1 && userType === 0" @click="goToEvaluate">
                            <div class="evaluate-title">请对{{patInfo.docName}}医生的服务评价</div>
                            <span>去评价</span>
                            <i class="el-icon-star-off" v-for="(item,index) in 5" :key="index"></i>
                        </div>
                        <!--评论消息-->
                        <div class="left-chart one-chart" v-if="item.chatType === 3 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <span class="chart-line message-content" style="max-width: 360px;box-sizing: border-box;">
                                    <div class="mb-10 line-height-25">
                                        {{item.content.comment}}
                                        <a href="javascript:void(0);" @click="risButtonClick">详情></a>
                                    </div>
                                    <div class="file-box">
                                        <div class="ris-data">
                                            <img v-if="item.content.sex === '男'" :src="require('../../assets/man.png')"/>
                                            <img v-else-if="item.content.sex === '女'" :src="require('../../assets/woman.png')"/>
                                            <img v-else :src="require('../../assets/unknown.png')"/>
                                            <strong class="fs-15">{{item.content.patientName}}</strong>
                                            <div v-if="item.content.sex === '男'" :class="`iconfont icon-xingbie-nan`"></div>
                                            <div v-else-if="item.content.sex === '女'" :class="`iconfont icon-xingbie-nv`"></div>
                                            <div class="fs-13">{{item.content.age}}</div>
                                        </div>
                                        <div class="ris-content fs-15">{{item.content.projectName}}</div>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div class="right-chart one-chart" v-if="item.chatType === 3 && item.chatPosition === 'right'">
                            <span class="chart-line message-content" style="max-width: 360px;box-sizing: border-box;">
                                <div class="mb-10 line-height-25">
                                    {{item.content.comment}}
                                    <a href="javascript:void(0);" @click="risButtonClick">详情></a>
                                </div>
                                <div class="file-box file-box-right">
                                    <div class="ris-data">
                                        <img v-if="item.content.sex === '男'" :src="require('../../assets/man.png')"/>
                                        <img v-else-if="item.content.sex === '女'" :src="require('../../assets/woman.png')"/>
                                        <img v-else :src="require('../../assets/unknown.png')"/>
                                        <strong class="fs-15">{{item.content.patientName}}</strong>
                                        <div v-if="item.content.sex === '男'" :class="`iconfont icon-xingbie-nan`"></div>
                                        <div v-else-if="item.content.sex === '女'" :class="`iconfont icon-xingbie-nv`"></div>
                                        <div class="fs-13">{{item.content.age}}</div>
                                    </div>
                                    <div class="ris-content fs-15">{{item.content.projectName}}</div>
                                </div>
                            </span>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <!--视频消息-->
                        <div class="left-chart one-chart" v-if="item.chatType === 6 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line" @click="sendVideoClick">
                                    <span class="message-content"><i class="fa fa-video-camera mr-10"></i>视频通话</span>
                                </div>
                            </div>
                        </div>
                        <div class="right-chart one-chart" v-if="item.chatType === 6 && item.chatPosition === 'right'">
                            <div class="chart-line" @click="sendVideoClick">
                                <span class="message-content">视频通话<i class="fa fa-video-camera ml-10"></i></span>
                            </div>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <!--病历消息-->
                        <div class="left-chart one-chart" v-if="item.chatType === 7 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line">
                                    <span class="message-content">
                                        <div class="patient-title">
                                            <img v-if="item.content.sex === 1" src="../../assets/man.png"/>
                                            <img v-else src="../../assets/woman.png"/>
                                            <span class="mr-10">{{item.content.patName}}</span>
                                            <i :class="['iconfont',item.content.sex === 1 ? 'icon-xingbie-nan':'icon-xingbie-nv','mr-10']"></i>
                                            <span>{{item.content.age}}</span>
                                        </div>
                                        <div class="patient-content">
                                            <!-- <div class="mb-8">
                                                <span class="sub-title">电话：</span>
                                                <span>{{item.content.telephone}}</span>
                                            </div> -->
                                            <div class="mb-8">
                                                <span class="sub-title">就诊：</span>
                                                <span>{{item.content.depName}}</span>
                                            </div>
                                            <div class="mb-8">
                                                <span class="sub-title">主述：</span>
                                                <span>{{item.content.question}}</span>
                                            </div>
                                            <div>
                                                <span class="sub-title">照片：</span>
                                                <div class="img-box">
                                                    <el-image v-for="(val,index) in item.content.caseUrls" :key="index" :src="val" :preview-src-list="srcList"></el-image>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="right-chart one-chart" v-if="item.chatType === 7 && item.chatPosition === 'right'">
                            <div class="chart-line">
                                <span class="message-content">
                                    <div class="patient-title">
                                        <img v-if="item.content.sex === 1" src="../../assets/man.png"/>
                                        <img v-else src="../../assets/woman.png"/>
                                        <span class="mr-10">{{item.content.patName}}</span>
                                        <i :class="['iconfont',item.content.sex === 1 ? 'icon-xingbie-nan':'icon-xingbie-nv','mr-10']"></i>
                                        <span>{{item.content.age}}</span>
                                    </div>
                                    <div class="patient-content">
                                        <!-- <div class="mb-8">
                                            <span class="sub-title">电话：</span>
                                            <span>{{item.content.telephone}}</span>
                                        </div> -->
                                        <div class="mb-8">
                                            <span class="sub-title">就诊：</span>
                                            <span>{{item.content.depName}}</span>
                                        </div>
                                        <div class="mb-8">
                                            <span class="sub-title">主述：</span>
                                            <span>{{item.content.question}}</span>
                                        </div>
                                        <div>
                                            <span class="sub-title">照片：</span>
                                            <div class="img-box">
                                                <el-image v-for="(val,index) in item.content.caseUrls" :key="index" :src="val" :preview-src-list="srcList"></el-image>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <!--应用功能消息-->
                        <div class="left-chart one-chart" v-if="item.chatType === 8 && item.content.msgType == 1 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line">
                                    <span class="message-content apply-msg" @click="applyFunc(item.content.type)">{{item.content.content}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="right-chart one-chart" v-if="item.chatType === 8 && item.content.msgType == 1 && item.chatPosition === 'right'">
                            <div class="chart-line">
                                <span class="message-content apply-msg" @click="applyFunc(item.content.type)">{{item.content.content}}</span>
                            </div>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <!--检查(3)、处方展示(2)-->
                        <div class="left-chart one-chart" v-if="item.chatType === 8 && (item.content.msgType == 2||item.content.msgType == 3) && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line">
                                    <span class="message-content">
                                        <div class="chat-title">
                                            <span>{{item.content.title}}</span>
                                            <div class="chat-sub-title">{{item.content.patName}}</div>
                                        </div>
                                        <div class="chat-msg-content">{{item.content.content}}</div>
                                        <div class="chat-msg-sub" v-if="item.content.msgType == 2">收货地址：{{item.content.receiptInfo}}</div>
                                        <!-- <el-button style="float:left" type="text" size="mini" v-if="item.content.msgType == 2 && item.content.receiptInfo !== '来院自取'" @click="applyFunc(1,item)">修改地址</el-button> -->
                                        <el-button style="float:right" type="warning" size="mini" @click="goUrl(item.content.url)">{{item.content.msgType == 2 ? '查看处方':'查看'}}</el-button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="right-chart one-chart" v-if="item.chatType === 8 && (item.content.msgType == 2||item.content.msgType == 3) && item.chatPosition === 'right'">
                            <div class="chart-line">
                                <span class="message-content" style="background-color:#fff!important">
                                    <div class="chat-title">
                                        <span>{{item.content.title}}</span>
                                        <div class="chat-sub-title">{{item.content.patName}}</div>
                                    </div>
                                    <div class="chat-msg-content">{{item.content.content}}</div>
                                    <div class="chat-msg-sub" v-if="item.content.msgType == 2">收货地址：{{item.content.receiptInfo}}</div>
                                    <!-- <el-button style="float:left" class="dark-green-text-button" type="text" size="mini" v-if="item.content.msgType == 2 && item.content.receiptInfo !== '来院自取'" @click="applyFunc(1,item)">修改地址</el-button> -->
                                    <el-button style="float:right" class="dark-green-button" type="success" size="mini" @click="goUrl(item.content.url)">{{item.content.msgType == 2 ? '查看处方':'查看'}}</el-button>
                                </span>
                            </div>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <!--自评表-->
                        <div class="left-chart one-chart" v-if="item.chatType === 8 && item.content.msgType == 4 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line">
                                    <span class="message-content">
                                        <div class="chat-title">{{item.content.name}}</div>
                                        <div class="chat-msg-content">{{item.content.description}}</div>
                                        <el-button style="float:right" type="text" size="mini" @click="goQuest(item.content)">填写问卷</el-button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="right-chart one-chart" v-if="item.chatType === 8 && item.content.msgType == 4 && item.chatPosition === 'right'">
                            <div class="chart-line">
                                <span class="message-content" style="background-color:#fff!important">
                                    <div class="chat-title">{{item.content.name}}</div>
                                    <div class="chat-msg-content">{{item.content.description}}</div>
                                    <el-button style="float:left" type="text" size="mini" @click="goQuest(item.content)">填写问卷</el-button>
                                </span>
                            </div>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <!--检查报告-->
                        <div class="left-chart one-chart" v-if="item.chatType === 8 && item.content.msgType == 5 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line">
                                    <span class="message-content">
                                        <div class="chat-title">检查报告</div>
                                        <div class="chat-msg-content" style="margin-bottom: 30px;" v-for="(v,i) in item.content.content" :key="i">
                                            <div>
                                                <span style="display:inline-block;width: 140px;">姓名：{{v.patName}}</span>
                                                <span>部门：{{v.dep}}</span>
                                            </div>
                                            <div>检查项目：{{v.itemName}}</div>
                                            <div>检查日期：{{v.checkDate}}</div>
                                            <el-button v-if="pageSize === 'small'" style="float:right" type="text" size="mini" @click="goUrl(v.url)">查看报告</el-button>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="right-chart one-chart" v-if="item.chatType === 8 && item.content.msgType == 5 && item.chatPosition === 'right'">
                            <div class="chart-line">
                                <span class="message-content" style="background-color:#fff!important">
                                    <div class="chat-title">检查报告</div>
                                    <div class="chat-msg-content" style="margin-bottom: 30px;" v-for="(v,i) in item.content.content" :key="i">
                                        <div>
                                            <span style="display:inline-block;width: 140px;">姓名：{{v.patName}}</span>
                                            <span>部门：{{v.dep}}</span>
                                        </div>
                                        <div>检查部位：{{v.itemName}}</div>
                                        <div>检查日期：{{v.checkDate}}</div>
                                        <el-button v-if="pageSize === 'small'" style="float:left" type="text" size="mini" @click="goUrl(v.url)">查看报告</el-button>
                                    </div>
                                </span>
                            </div>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                        <!--电子病历-->
                        <div class="left-chart one-chart" v-if="item.chatType === 8 && item.content.msgType == 100 && item.chatPosition === 'left'">
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                            <div class="name-chart">
                                <div class="left-name">{{item.sendUser.userName}}</div>
                                <div class="chart-line">
                                    <span class="message-content">
                                        <div class="chat-title">
                                            <span>{{item.content.patName}}</span>
                                            <span>{{item.content.title}}</span>
                                        </div>
                                        <div class="chat-msg-content" >
                                            <div>{{item.content.content}}</div>
                                            <el-button v-if="pageSize === 'small'" style="float:right" type="text" size="mini" @click="goUrl(item.content.url)">查看病历</el-button>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="right-chart one-chart" v-if="item.chatType === 8 && item.content.msgType == 100 && item.chatPosition === 'right'">
                            <div class="chart-line">
                                <span class="message-content" style="background-color:#fff!important">
                                    <div class="chat-title">
                                        <span>{{item.content.title}}</span>
                                        <span style="float:right">{{item.content.patName}}</span>
                                    </div>
                                    <div class="chat-msg-content" >
                                        <div>{{item.content.content}}</div>
                                        <el-button v-if="pageSize === 'small'" style="float:right" type="text" size="mini" @click="goUrl(item.content.url)">查看详情</el-button>
                                    </div>
                                </span>
                            </div>
                            <div class="avatar" :style="`background:url(${item.sendUser.avatarImageUrl ? item.sendUser.avatarImageUrl :require('../../../static/avatar.jpg')}) center no-repeat;`"></div>
                        </div>
                    </div>
                </div>
            </div>
            <audio id="audioVoice" class="hide"></audio>
            <!-- <ky-preview-dialog :url="url" :blob="blob" :visible.sync="visible" :type="previewType"></ky-preview-dialog> -->
            <!-- <div v-show="menuShow" id="rightMenu" unselectable="on">
                <div v-if="menuType.includes('multiple')" @click="multipleCheck">多选</div>
                <div v-if="menuType.includes('word')" @click="toWord">转文字</div>
                <div v-if="menuType.includes('revocation')" @click="revocationMsg">撤回</div>
                <div v-if="menuType.includes('copy')" @click="copyText">复制</div>
            </div> -->
            <div class="black-model" @click.stop="patDialogShow = false" v-if="patDialogShow">
                <div class="pat-card" @click.stop="()=>{}">
                    <div class="patient-title">
                        <img v-if="patInfo.sex === 1" src="../../assets/man.png"/>
                        <img v-else src="../../assets/woman.png"/>
                        <span class="mr-10">{{patInfo.patName}}</span>
                        <i :class="['iconfont',patInfo.sex === 1 ? 'icon-xingbie-nan':'icon-xingbie-nv','mr-10']"></i>
                        <span>{{patInfo.age}}</span>
                    </div>
                    <div class="patient-content">
                        <!-- <div class="mb-8">
                            <span class="sub-title">电话：</span>
                            <span>{{patInfo.telephone}}</span>
                        </div> -->
                        <div class="mb-8">
                            <span class="sub-title">就诊：</span>
                            <span>{{patInfo.depName}}</span>
                        </div>
                        <div>
                            <span class="sub-title">主述：</span>
                            <span>{{patInfo.question}}</span>
                        </div>
                        <div>
                            <span class="sub-title">照片：</span>
                            <div class="img-box">
                                <el-image v-for="(val,index) in patInfo.caseUrls" :key="index" :src="val" :preview-src-list="srcList"></el-image>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <input style="z-index:999" ref="excel-upload-input" type="file" accept=".mp3, .mp4" @change="getFileData" > -->
            <editAddressDialog :visible.sync="addressVisible" :patInfo="patInfo" :chatItem.sync="chatItem"></editAddressDialog>
        </div>
</template>

<script>
import {getChartData, voiceToWordApi, closeGroup, messageReCall} from '../../api/api.js'
import emojis from '../../assets/emojis.json'
import editAddressDialog from './editAddressDialog.vue'
// const kyPreviewDialog = require('kyui-plus')
// import wx from 'weixin-js-sdk'
// const {voiceTime, API_ROOT} = require('../../../static/config.js')
/* const config = require('../../../static/config.js')
const API_ROOT = (window.httpConfig && window.httpConfig.CHAT_API_ROOT) ? window.httpConfig.CHAT_API_ROOT : config.API_ROOT
const voiceTime = (window.httpConfig && window.httpConfig.CHAT_VOICE_TIME) ? window.httpConfig.CHAT_VOICE_TIME : config.voiceTime */
export default {
  name: '',
  mixins: [],
  components: {editAddressDialog}, // kyPreviewDialog
  props: {
    clickItem: {
      type: Object,
      default: () => {}
    },
    pageType: {
      type: String,
      default: ''
    },
    myUserId: {
      type: String,
      default: ''
    },
    mySelfData: {
      type: Object,
      default: () => {}
    },
    API_ROOT: {
      String,
      default: ''
    },
    voiceTime: {
      Number,
      default: 0
    },
    otherSys: {
      Boolean,
      default: false
    },
    pageSize: {
      String,
      default: 'large'
    },
    userType: {
      Number,
      default: 0
    },
    patInfo: {
      Object,
      default: () => {}
    },
    closedChat: {// 会话是否已结束
      Boolean,
      default: false
    }
  },
  data () {
    return {
      userName: '',
      chatList: [],
      timeChazhi: 5 * 60 * 1000, // 消息差的时长5分钟
      maxVoiceWidth: 180, // 语音最长宽度
      voiceTimeout: null,
      lastChatTime: null,
      lastContentTime: null,
      canGetNext: true,
      imgList: [], // 聊天图片链接
      url: '',
      blob: '',
      visible: false,
      previewType: '',
      checkText: [],
      srcList: [], // 病历图片链接
      menuShow: false,
      showCheckbox: false,
      isWeiXin: false,
      patDialogShow: false,
      addressVisible: false,
      menuType: '', // 右键菜单类型
      chatItem: {}
    }
  },
  watch: {
    clickItem: {
      handler (val) {
        if (val && val.id) {
          this.userName = this.clickItem.name
          this.getFirstPageChat()
        }
      },
      deep: true,
      immediate: true
    },
    patInfo (val) {
      if (val) {
        this.srcList = val.caseUrls
      }
    }
  },
  computed: {},
  created () {},
  mounted () {
    // 监听滚动条滚动
    document.getElementById('divContent').onscroll = (e) => {
      let scrollTop = e.target.scrollTop
      if (scrollTop <= 100 && scrollTop > 0) {
        let params = {
          userId: this.myUserId,
          otherId: this.clickItem.id,
          type: this.clickItem.type,
          startTime: this.lastContentTime,
          pageSize: 15
        }
        if (this.canGetNext && this.chatList && this.chatList.length > 0 && this.lastContentTime) {
          this.getChatLog(params).then(res => {
            this.$nextTick(() => {
              let height2 = document.getElementById('divContent').scrollHeight
              document.getElementById('divContent').scrollTop = height2 - this.height1 + scrollTop
            })
          })
        }
      }
    }
  },
  methods: {
    down (e, type, item, position) { // 鼠标按下
      console.log('手指按下')
      //   if (!this.menuShow) {
      //   e.preventDefault() // 这个是为了阻止默认的菜单出现。加了这个移动端触发不了点击事件，图像不能大图预览了 。如果不去除默认事件，右键菜单又会很难出现。现在只兼容小程序的，不去除默认事件
      //   }
      this.clickTime = setTimeout(() => {
        this.showRightMenu(e, type, item, position)
        this.lock = false
      }, 1000)
    },
    up (e) { // 鼠标抬起
      clearTimeout(this.clickTime)
      setTimeout(() => {
        this.lock = true
      }, 0)
    },
    msgClick (e) {
      if (this.lock) {
        console.log('单击事件')
      } else { // 长按事件就禁止冒泡
        console.log('长按事件')
        // e.cancelBubble = true
      }
    },
    risButtonClick () {
      let data = {
        type: 'openRis',
        data: {
          id: this.clickItem.id
        }
      }
      this.$chatUtils.postToParent(data)
    },
    settingClick (openFlag) {
    // 关闭历史记录，打开群管理页面
      this.$emit('settingClick', openFlag)
    },
    finishChat () { // 结束会话
      let params = {
        groupId: this.clickItem.id,
        userId: this.myUserId
      }
      closeGroup(params).then(data => {
        this.$emit('update:closedChat', true)
      })
    },
    getFirstPageChat () {
      // 获取已有的聊天记录
      let params = {
        userId: this.myUserId,
        otherId: this.clickItem.id,
        type: this.clickItem.type,
        // eslint-disable-next-line no-undef
        startTime: this.$dayjs().format('YYYY-MM-DD 23:59:59'),
        pageSize: 15
      }
      this.lastChatTime = null
      this.chatList = []
      this.imgList = []
      this.getChatLog(params).then(res => {
        if (this.chatList.length > 0) {
          let obj = this.chatList[this.chatList.length - 1]// 最新一条消息是会话已结束就把会话状态置为关闭
          if (obj.chatType === 5 && obj.content === '会话已结束' && this.userType === 0) { // 患者才关闭会话
            this.$emit('update:closedChat', true)
          }
        }
        this.$nextTick(() => {
          setTimeout(() => {
            document.getElementById('divContent').scrollTop = document.getElementById('divContent').scrollHeight
          }, 10)
          this.$emit('closeLoading')// 跳转进来有loading的话先关闭loading
        })
      })
    },
    getChatLog (params) {
      return new Promise(async (resolve, reject) => {
        if (this.canGetNext) {
          this.canGetNext = false
          await getChartData(params).then(data => {
            if (data && data.length > 0) {
              this.lastContentTime = data[0].createdTime
              this.tempArr = []
              this.tempImgList = []
              //   this.setChatListUser(data)
              data.forEach((el, i) => {
                if (i === 0) {
                  this.setChatListFunc(el, false, true)
                } else {
                  this.setChatListFunc(el, false, false)
                }
              })
              this.chatList = this.tempArr.concat(this.chatList)
              this.imgList = this.tempImgList.concat(this.imgList)
              this.height1 = document.getElementById('divContent').scrollHeight
              resolve()
            }
          }).finally(() => {
            this.canGetNext = true
          })
        }
      })
    },
    setChatListUser (list) { // 处理chatList,把对话的用户信息塞进去
      let data = null
      if (this.clickItem.type === 0) { // 单聊
        data = [this.clickItem, this.mySelfData.user]
      } else if (this.clickItem.type === 1) { // 群聊
        data = this.clickItem.users
      }
      list.forEach((v) => {
        data.forEach((g) => {
          if (v.sendUserId === g.id) {
            v.sendUser = g
          }
        })
      })
    },
    setChatListFunc (el, isAddToList, isAddToTime) { // 设置聊天消息 -- 聊天数据，receive来的数据直接追加到最后一条 isAddToList:是否追加消息   isAddToTime：是否追加时间
      // 设置时间
      let chazhi = new Date(el.createdTime).getTime() - new Date(this.lastChatTime).getTime()

      if (chazhi > this.timeChazhi || !this.lastChatTime || isAddToTime) { // 两条消息间隔时长大于5分钟则画时间
        let obj = {
          chatType: 99,
          createdTime: el.createdTime
        }
        let dayType = this.$chatUtils.judgeTime(el.createdTime)
        if (dayType === 0) { // 今天发的消息只显示时分秒
          obj.createdTime = el.createdTime.substring(10)
        }

        if (isAddToList) { // receive来的消息
          this.chatList.push(obj) // 放到最后一条
        } else {
          this.tempArr.push(obj)
        }
      }
      this.lastChatTime = el.createdTime

      // 设置消息
      if (el.chatType !== 5) { // 不是其余消息就处理放两侧
        let content = this.dealContent(el.content, el.chatType)
        el.content = content
        el.checked = false
        if (el.sendUser.id === this.myUserId) {
          el.chatPosition = 'right'
        } else { // 别人的消息
          el.chatPosition = 'left'
        }
        if (el.chatType === 1) {
          this.dealToImgList(content, isAddToList)// 图片的话要放进预览里
        }
        if (isAddToList) {
          this.chatList.push(el)
          this.$forceUpdate()
          this.$nextTick(() => {
            setTimeout(() => {
              document.getElementById('divContent').scrollTop = document.getElementById('divContent').scrollHeight
            }, 50)
          })
        } else {
          this.tempArr.push(el)
        }
      } else {
        if (isAddToList) {
          if (el.content.indexOf('撤回') > -1) {
            this.dealRecallMsg(el) // 处理接收的撤回消息
          } else {
            this.chatList.push(el) // 放到最后一条
          }
          this.$forceUpdate()
        //   this.$nextTick(() => {//追加的系统消息，滚动条不到最底部
        //     setTimeout(() => {
        //       document.getElementById('divContent').scrollTop = document.getElementById('divContent').scrollHeight
        //     }, 50)
        //   })
        } else {
          if (el.content.indexOf('撤回') > -1) {
            this.recallAppendName(el)
          }
          this.tempArr.push(el)
        }
      }
    },
    dealToImgList (content, isAddToList) {
      if (isAddToList) {
        this.imgList.push(content)
      } else {
        this.tempImgList.push(content)
      }
    },
    dealContent (content, chatType) {
      if (chatType === 2) { // 文件消息
        let obj = JSON.parse(content)
        console.log('附件obj', content)
        if (obj) {
          let typeImg = this.getFileType(obj.fileSuffix)
          obj.typeImg = typeImg
        } else {
          obj = {
            typeImg: 'file_unknown.png'
          }
        }
        return obj
      } else if (chatType === 3) { // 评论消息
        let obj = JSON.parse(content)
        let img = ''
        let icon = ''
        if (obj.sex === '1') {
          img = 'man.png'
          icon = 'icon-xingbie-nan'
        } else if (obj.sex === '2') {
          img = 'woman.png'
          icon = 'icon-xingbie-nv'
        } else {
          img = 'unknown.png'
          icon = 'icon-xingbie_weizhi'
        }
        let comment = obj.comment
        if (comment.length > 42) {
          obj.comment = comment.substring(0, 44)
          obj.comment += '...'
        }
        obj.img = img
        obj.icon = icon

        return obj
      } else if (chatType === 4) { // 语音消息
        let obj = JSON.parse(content)
        let width = this.maxVoiceWidth * (Number(obj.Time) / this.voiceTime)
        obj.width = width
        return obj
      } else if (chatType === 0) { // 普通文字消息---处理表情编码
        content = this.strToEmoji(content)
        return content
      } else if (chatType === 7) { // 患者病历消息
        try {
          content = content.replaceAll('\u0000', '')
          content = JSON.parse(content)
        } catch (error) {
          if (error.toString().indexOf('}') > -1) { // 结尾缺少}导致的报错，需补齐再转json对象
            content = JSON.parse(content + '}')
          }
        }
        this.srcList = content.caseUrls
        return content
      } else if (chatType === 8) { // 应用功能消息
        content = JSON.parse(content)
        if (content.msgType === 5) {
          content.content = JSON.parse(content.content)
        }
        return content
      } else {
        return content
      }
    },
    dealRecallMsg (obj) { // 处理接收的撤回消息
      if (obj.chatType === 5) {
        let content = obj.content.split('|')[0]
        let msgId = obj.content.split('|')[1]
        let index = this.chatList.findIndex((v) => {
          return v.id === msgId || v.messageId === msgId
        })
        if (obj.sendUser.id === this.myUserId) {
          content = '你' + content
        } else {
          content = obj.sendUser.userName + content
        }
        obj.content = content
        this.chatList.splice(index, 1, obj)
      }
    },
    recallAppendName (el) { // 撤回消息----添加发送人名
      let content = el.content
      if (el.sendUser.id === this.myUserId) {
        content = '你' + content
      } else {
        content = el.sendUser.userName + content
      }
      el.content = content
    },
    strToEmoji (val) { // 表情转换编码
      for (const key in emojis) {
        // eslint-disable-next-line no-undef
        const el = emojis[key]
        // val = val.replaceAll(el.keywords, el.char)
        let reg = new RegExp(el.keywords, 'g')
        val = val.replace(reg, el.char)// 去除掉回车带来的换行
      }
      return val
    },
    getFileType (fileSuffix) {
      let typeImg = ''
      let suffix = fileSuffix.toLowerCase()
      if (['txt'].includes(suffix)) {
        typeImg = 'file_txt.png'
      } else if (['mp4', 'avi', 'flv', 'm3u8', 'rmvb', 'mvb'].includes(suffix)) {
        typeImg = 'file_avi.png'
      } else if (['xls', 'xlsx', 'et', 'ett', 'xlt', 'xlsm', 'dbf', 'xml'].includes(suffix)) {
        typeImg = 'file_Excel.png'
      } else if (['mp3', 'wma'].includes(suffix)) {
        typeImg = 'file_MP3.png'
      } else if (['pdf'].includes(suffix)) {
        typeImg = 'file_pdf.png'
      } else if (['ppt', 'pptx'].includes(suffix)) {
        typeImg = 'file_ppt.png'
      } else if (['doc', 'docx'].includes(suffix)) {
        typeImg = 'file_world.png'
      } else if (['zip', 'rar'].includes(suffix)) {
        typeImg = 'file_zip.png'
      } else {
        typeImg = 'file_unknown.png'
      }
      return typeImg
    },
    previewFile (id, fileSuffix) { // 在线预览
      this.url = `${this.API_ROOT}/sysFileInfo/download?id=${id}`
      this.visible = true
      this.previewType = fileSuffix.split('.')[1] || fileSuffix

      /*  var x = new XMLHttpRequest()
      x.open('GET', `${API_ROOT}/sysFileInfo/download?id=${id}`, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        this.blob = x.response
      }
      x.send() */
    },
    weixinPreview (id, fileSuffix) { // 转微信预览
      let url = `${this.API_ROOT}/sysFileInfo/download?id=${id}&fileType=${fileSuffix}`
      // eslint-disable-next-line no-undef
      wx.miniProgram.navigateTo({
        url: `/pagesD/fileUpload/fileUpload?url=` + encodeURIComponent(url)
        // url: `../test/test?url=` + encodeURIComponent(url)
      })
    },
    downloadFile (id, fileName) {
      var x = new XMLHttpRequest()
      x.open('GET', `${this.API_ROOT}/sysFileInfo/download?id=${id}`, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        var url = window.URL.createObjectURL(x.response)
        var a = document.createElement('a')
        a.href = url
        a.download = fileName
        a.click()
      }
      x.send()
    },
    voiceLineClick (item) {
      let audio = document.getElementById('audioVoice')
      if (item.voicePlay) {
      // 关闭
        this.$set(item, 'voicePlay', false)
        audio.pause()
        if (this.voiceTimeout) {
          clearTimeout(this.voiceTimeout)
        }
      } else {
      // 打开
        if (this.lastVoice) { // 有上一个就先关闭上一个
          this.$set(this.lastVoice, 'voicePlay', false)
        }
        this.$set(item, 'voicePlay', true)
        this.lastVoice = item
        audio.setAttribute('src', item.content.Data)// 放上录音地址
        setTimeout(() => {
          audio.play()
          audio.oncanplay = () => {
            audio.play()
          }
          audio.onreadystatechange = () => {
            if (audio.readyState > 1) {
              audio.play()
            }
          }
        }, 100)
        this.voiceTimeout = setTimeout(() => {
          this.$set(item, 'voicePlay', false)
          this.voiceTimeout = null
          this.lastVoice = null
        }, item.content.Time * 1000)
      }
    },
    checkData (val, isCheck) {
      // 选择文字
      if (isCheck) {
        this.checkText.push(val)
      } else {
        let index = this.checkText.findIndex((item) => {
          return item === val
        })
        this.checkText.splice(index, 1)
      }
      this.$emit('checkDataChange', this.checkText.length)
      this.$forceUpdate()
    },
    clickAndCheck (item, val) {
      if (this.showCheckbox) {
        item.checked = !item.checked
        this.checkData(val, item.checked)
      }
    },
    showRightMenu (e, type, item, position) { // multiple 多选,word 转语音 revocation 撤回 multiple 多选
      console.log('e.....', e)
      this.menuType = type

      if (this.menuType.includes('revocation')) { // 大于3分钟不给撤回消息
        let time1 = this.$dayjs(item.createdTime)
        let time2 = this.$dayjs()
        let minute = time2.diff(time1, 'minute')
        if (minute > 3) { // 大于3分钟不给撤回
          let index = this.menuType.findIndex((val) => {
            return val === 'revocation'
          })
          this.menuType.splice(index, 1)
        }
      }
      // 选中文字
      const range = document.createRange()
      range.selectNode(e.target)
      window.getSelection().removeAllRanges()
      window.getSelection().addRange(range)

      this.menuShow = true
      this.rightData = item// 右键选中的信息
      this.$nextTick(() => {
        let menu = this.getRightMenu(this.menuType)
        menu.style.top = '-38px'
        menu.style[position] = 'auto' // 把上一次的清空一下
        menu.style[position === 'left' ? 'right' : 'left'] = `calc(50% - ${this.menuType.length * 40}px)`// 40 一个按钮的一半宽度
        if (menu.offsetWidth >= e.target.offsetWidth + 40 * 2) { // 大于对话框长度+右侧宽度（40）的两倍，需减去超出部分
          // 减去超出的部分
          let w = (menu.offsetWidth - (e.target.offsetWidth + 40 * 2)) / 2
          menu.style[position === 'left' ? 'right' : 'left'] = `calc(50% - ${this.menuType.length * 40 + w}px)`
        }
        e.target.offsetParent.appendChild(menu)
      })
    },
    getRightMenu (type) { // 得到右键的菜单节点
      let dom = document.getElementById('rightMenu')
      if (dom) {
        dom.parentNode.removeChild(dom)
      }
      dom = document.createElement('div')
      dom.setAttribute('id', 'rightMenu')
      dom.setAttribute('class', 'rightMenu')
      type.forEach(v => {
        let node = document.createElement('div')
        let textNode = null
        if (v === 'multiple') {
          textNode = document.createTextNode('多选')
          node.onclick = this.multipleCheck
        } else if (v === 'word') {
          textNode = document.createTextNode('转文字')
          node.onclick = this.toWord
        } else if (v === 'revocation') {
          textNode = document.createTextNode('撤回')
          node.onclick = this.revocationMsg
        } else if (v === 'copy') {
          textNode = document.createTextNode('复制')
        }
        if (textNode) {
          node.appendChild(textNode)
          dom.appendChild(node)
        }
      })
      return dom
    },
    closeMenu () { // 关闭右键菜单
      let dom = document.getElementById('rightMenu')
      if (dom) {
        dom.parentNode.removeChild(dom)
      }
    },
    multipleCheck () { // 点击多选
      this.showCheckbox = true
      this.$emit('openMultiple')
    },
    toWord () { // 语音转文字
      let file = this.$chatUtils.base64ToFile(this.rightData.content.Data, '录音')
      let params = {
        file
      }
      console.log('file......', file)
      voiceToWordApi().then(res => {
        // this.rightData.content.word = res.data
        console.log('res.........', res)
        this.rightData.content.word = res
      })

      // 下载
      /*  let blob = this.$chatUtils.base64ToBlob(this.rightData.content.Data, '录音')
      let myUrl = URL.createObjectURL(blob)
      this.downloadFile2(myUrl, '录音.mp3') */
    },
    revocationMsg () { // 撤回消息
    //   this.rightData // 右键选中信息
      let params = {
        userId: this.myUserId,
        messageId: this.rightData.id || this.rightData.messageId
      }
      messageReCall(params)
    },
    copyText (e) { // 复制对话框文字
      setTimeout(() => {
        if (navigator.clipboard) {
          var selection = window.getSelection()
          if (selection.rangeCount > 0) {
            var range = selection.getRangeAt(0)
            navigator.clipboard
              .writeText(range.toString())
              .then(() => alert('移动设备上复制成功'))
              .catch((err) => alert('复制失败', err))
          }
        } else {
          document.execCommand('copy')
        }
        window.getSelection().removeAllRanges()
      }, 500)
    },
    downloadFile2 (url, name) {
      var a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', name)
      a.setAttribute('target', '_blank')
      let clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    },
    getFileData (e) {
      const files = e.target.files
      let file = files[0]
      console.log('mp3', file)
    //   this.toWord(file)
    },
    closeMultiple () {
      this.showCheckbox = false
      this.checkText = []
      this.chatList.forEach(v => {
        v.checked = false
      })
      this.$emit('checkDataChange', 0)
    },
    copyChat () { // 多选功能里的复制文字
      let area = document.createElement('textarea')
      let word = this.checkText.join('<br/>')
      area.innerText = word
      document.body.appendChild(area)
      area.select()
      document.execCommand('Copy')
      document.body.removeChild(area)
    },
    applyFunc (type, item) { // 应用功能点击
      if (type === 1) { // 填写地址功能
        this.addressVisible = true
        this.chatItem = item
      }
    },
    goUrl (url) { // 跳转链接
      // eslint-disable-next-line no-undef
      wx.miniProgram.navigateTo({
        url: url
      })
    },
    sendVideoClick () {
      if (this.userType === 0) { // 患者无通话权限
        this.$message.error('无通话权限')
        return
      }
      if (this.closedChat || this.clickItem.groupStatus === 2) {
        this.$message.error('会话已结束')
        return
      }
      /* if (this.patInfo.askType !== 2 && this.patInfo.consultType !== 6) { // 视频
        this.$message.error('无通话权限')
        return
      } */
      this.$emit('goInVideo')
    },
    goToEvaluate () { // 去评价
      wx.miniProgram.navigateTo({
        url: `/pagesG/pages/evaluateList/apply?id=${this.patInfo.id}&hiId=${this.patInfo.hiId}`
      })
    },
    goQuest (content) {
      this.goUrl('/pagesE/pages/questionnaire/write?key=' + content.key + '&patId=' + this.patInfo.patId)
    }
  },
  beforeDestroy () {},
  destroyed () {},
  beforeUpdate () {},
  updated () {}
}
</script>
<style lang='scss' scoped>
.chat-content{
    min-height: calc(100% - 460px);
    flex:1;
    display: flex;
    flex-direction: column;
    .title{
        width:100%;
        height:54px;
        border-bottom: 1px solid rgba(0,0,0,0.1);
        text-align: center;
        line-height: 54px;
        background: #fff;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .flex-right{
        justify-content: flex-end!important;
    }
    .file-text .file-name{
        margin-bottom: 5px;
        color: #1D2129;
        max-width:130px;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
    }
    .file-text .file-size{
        color: rgba(134, 144, 156, 1);
        display: inline-block;
        font-size: 12px;
    }
    .file-text .file-size-right{
        color: #e5e5e5bd;
    }
    .title-button{
        position: absolute;
        right: 0px;
        top: 10px;
        margin-right: 10px;
        line-height: 35px;
    }
    .pat-top-info{
        display: flex;
        justify-content: space-between;
        padding: 5px 10px;
        box-sizing: border-box;
        align-items: stretch;
        width: 100%;
        height: 36px;
        border-bottom: 1px solid rgba(0,0,0,0.1);
        text-align: center;
        line-height: 26px;
        background: #fff;
        cursor: pointer;
        .close-button{
            border-radius: 14px;
            border: 1px solid #0db4aa;
            color: #0db4aa;
            width: 80px;
            cursor:pointer;
        }
    }
    .quest-top-info{
        padding: 5px 10px;
        box-sizing: border-box;
        width: 100%;
        height: 36px;
        border-bottom: 1px solid rgba(0,0,0,0.1);
        text-align: center;
        line-height: 26px;
        background: #fff;
        cursor: pointer;
        .sub-title{
            color:#919398;
        }
    }
    #divContent{
        height: 100%;
        overflow: scroll;
        .one-chart{
            padding: 10px 10px;
            position: relative;
        }
        .one-chart .unRead{
            color:#7FBC56;
            font-size:12px;
        }
        .one-chart .read{
            color:#B2B3B5;
            font-size:12px;
        }
        .chart-div{
            max-width: 100%;
            .one-chart{
                max-width:calc(100% - 20px);
                .chart-line{
                    max-width:calc(100vw - 115px);
                }
            }
        }
        .checked-chart{
            background: #ddd;
        }
        .right-chart{
            text-align: right;
            /deep/ .el-checkbox__inner{
                background-color:#fff!important;
            }
            .avatar{
                float: right;
                margin-left: 5px;
                width: 35px;
                height: 35px;
                border-radius: 5px;
                background-size: cover!important;
            }
            .file-text {
                float: right;
                margin-right: 5px;
                .file-name{
                    text-align: left;
                }
            }
            .message-content {
                padding: 9px 12px;
                border-radius: 10px 10px 0 10px;
                /* margin-right: 4px; */
                display: inline-block;
                text-align: left;
                word-break: break-word;
                // background: #0FC6C2!important;
                color: #333333;
                max-width: 500px;
            }

        }
        .img-box{
            width: 100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-content: flex-start;
            .el-image{
                min-width: 30%;
                margin: 3px;
                width: calc(33% - 6px);
                height: 100px;
                flex: 1;
                max-width: calc(33% - 4px);
              /deep/  .el-image__preview{
                    object-fit: contain;
                }
            }
        }
        .chat-title{
            font-weight:600;
            border-bottom:1px solid #ddd;
            padding-bottom:5px;
            display: inline-block;
            width: 100%;
        }
        .chat-sub-title{
            font-weight:500;
            float:right;
        }
        .chat-msg-content{
            margin: 5px 0;
        }
        .chat-msg-sub{
            color:#838383;
            font-size:13px;
        }
        .evaluate-box{
            background: rgb(255, 255, 255);
            text-align: center;
            width: 215px;
            margin: auto;
            padding: 15px;
            border-radius: 15px;
            cursor: pointer;
            .evaluate-title{
                text-align: center;
                margin-bottom: 5px;
            }
        }
        .left-chart{
            .avatar{
                float: left;
                margin-right: 5px;
                width: 35px;
                height: 35px;
                border-radius: 5px;
                margin-top: 6px;
                background-size: cover!important;;
            }
            .name-chart{
                margin-left: 40px;
            }
            .left-name{
                font-size: 12px;
                color: #707070;
            }
            .message-content {
                background: #fff;
                padding: 9px 12px;
                border-radius: 10px 10px 10px 0px;
                display: inline-block;
                text-align: left;
                word-break: break-word;
                max-width: 500px;
            }
            .file-text{
                float: left;
                margin-right: 5px;
                .file-name{
                    text-align: right;
                }
            }
        }
        .apply-msg{
            color: #3098af!important;
            font-weight: 600;
            text-decoration: underline;
            cursor: pointer;
        }
        .patient-title{
            border-bottom:1px solid#F2F2F2;
            padding-bottom: 8px;
            img{
                margin-right: 16px;
                float: left;
            }

        }
        .patient-content{
            margin-top: 12px;
            .sub-title{
                color: #919398;
            }
        }
        .right-menu{
            width: 180px;
            height: 80px;
        }
        .one-chart .chart-line{
            display: inline-block;
            position: relative;
            // max-width: calc(100% - 55px);
        }
        .chart-line .ris-detail{
            position: absolute;
            top: 30px;
            right: 20px;
        }
        .msg-checkbox-right{
            float: right;
            line-height: 35px;
            margin-left: 5px;
            z-index: 0;
        }
        .msg-checkbox-left{
            float: left;
            line-height: 50px;
            margin-right: 5px;
            z-index: 0;
        }
        .voice-block{
            min-width: 45px;
            width: 150px;
            text-align: right!important;
            // display: flex!important;
            // align-items: center;
            div{
                margin:0 3px;
            }
            .voice-word-left{
                border-top: 1px solid #ddd;
                padding-top: 5px;
                margin-top: 9px;
                text-align: right;
                word-break: break-word;
                max-width:300px
            }
            .voice-word-right{
                border-top: 1px solid #ddd;
                padding-top: 5px;
                margin-top: 9px;
                text-align: left;
                word-break: break-word;
                max-width:300px
            }
            .flex-item{
                display: flex;
                align-items: center;
            }
        }
        .trumpet-right{
            background:url('../../assets/voice-black.png') right 0 no-repeat;
            transform: rotate(180deg);
            position: absolute;
            top: 11px;
            right: 35px;
        }
        .trumpet-left{
            background:url('../../assets/voice-black.png') right 0 no-repeat;
            position: absolute;
            top: 11px;
            left: 35px;
        }
        .trumpet {
            width: 16px;
            height: 16px;
            background-size: 400%;
            display: inline-block;
        }
        .time-msg {
            text-align: center;
            color: #919398;
        }
        .other-msg {
            text-align: center;
            padding: 10px;
            span {
                margin: auto;
                font-size: 12px;
                color: #606060;
                padding: 8px;
                background: #d1d1d1;
                border-radius: 8px;
            }
        }
        .file-box{
            width: auto;
            background: #00000008;
            padding: 9px;
            border: 1px solid #ddd0;
            overflow: hidden;
            border-radius: 6px;
            a{
                color: #3371a7;
                text-decoration: none;
                font-size: 12px;
            }
        }
        .file-box-right{
            background: #FFFFFF!important;
        }
        .ris-data{
            line-height: 23px;
            text-align: left;
            color: #1D2129;
            div,strong{
                display: inline-block;
                margin: 0 3px;
            }
            img{
                float: left;
                margin: 0 3px;
            }
        }
        .ris-content{
            margin-top: 8px;
            font-weight: 600;
            color: #1D2129;
        }
    }
    .content-micro{
        height: calc(100% - 55px);
        flex:1;
        position: relative;
        // background: #dddddd52;
        background: #f3f3f352;
    }
    .more-icon{
       /*  position: absolute;
        right: 20px;
        top: 15px; */
        float: right;
        margin-right: 15px;
    }
    .button-icon{
        // position: absolute;
        font-size: 24px;
        margin-right: 15px;
        // right: 20px!important;
        // top: 10px!important;
    }
    .finish-button{
        margin-right: 15px;
    }
    .more-icon-2{
        /* position: absolute;
        right: 50px;
        top: 15px; */
        float: right;
        margin-right: 15px;
    }
    .voicePlay {
        animation-name: voicePlay;
        animation-duration: 1s;
        animation-direction: normal;
        animation-iteration-count: infinite;
        animation-timing-function: steps(3);
    }

    .mr-10{
        margin-right:10px
    }
    .mb-8{
        margin-bottom:8px;
    }
    .ml-45{
        margin-left: 45px;
    }

  /deep/  .rightMenu{
        max-width: calc(100vw - 20px);
        display: flex;
        background: #fff;
        position: absolute;
        z-index: 999;
        text-align: center;
        box-shadow: 5px 5px 15px #9b9b9b99;
        user-select: none;
        -ms-user-select:none;
        border-radius: 5px;
        div{
            line-height: 35px;
            cursor: pointer;
            width: 80px;
        }
        div:hover{
            background: #dfdfdf78;
        }
    }

    .black-model{
        width:100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        position: absolute;
        z-index: 999;
        display: flex;
        .pat-card{
            width:80%;
            background: #E8FFFB;
            border-radius: 15px;
            margin: auto;
            padding: 15px;
            .patient-title{
                border-bottom:1px solid#F2F2F2;
                padding-bottom: 8px;
                img{
                    margin-right: 16px;
                    float: left;
                }

            }
            .patient-content{
                margin-top: 12px;
                .sub-title{
                    color: #919398;
                }
            }
        }
    }
    .icon-xingbie-nan{
        color: #3491FA;
    }
    .icon-xingbie-nv{
        color:#d4237a;
    }
    .dark-green-button{
        background-color: #0DB4AA;
        border-color: #0DB4AA;
    }
    .dark-green-text-button{
        color: #0DB4AA;
    }
    @keyframes voicePlay {
        0% {
            background-position: 0;
        }
        100% {
            background-position: 100%;
        }
    }
    a {
        color: #3371a7;
        text-decoration: none;
    }
    /deep/ .el-image__inner--center{
        position:static;
        transform: none;
    }

    @media screen and (max-width:663px){/* 手机 */
        .title{
            font-size: 17px;
        }
        #divContent .right-chart span,#divContent .left-chart span{
            font-size: 16px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// packages/chat/src/chat-content.vue